module.exports = __webpack_public_path__ + "media/images/cz25-154b307209d90bc673c6f5c643c4a002.svg";